import React from 'react';

interface SlidePickerProps {
  currentSlideIndex: number;
  totalSlides: number;
  onSelectSlide: (slideIndex: number | null) => void;
  onClose: () => void;
}

export const SlidePicker: React.FC<SlidePickerProps> = ({
  currentSlideIndex,
  totalSlides,
  onSelectSlide,
  onClose,
}) => {
  return (
    <div className="absolute bottom-[74px] left-1/2 -translate-x-1/2 mb-2">
      <div className="bg-[rgba(32,40,53,0.9)] border-2 border-[#DFE4EA] backdrop-blur-[12.5px] rounded-lg overflow-hidden">
        <div className="px-4 py-3 border-b border-[#DFE4EA]">
          <div className="text-[#DFE4EA] text-sm font-medium">Unlock after slide:</div>
        </div>
        <div className="max-h-[300px] overflow-y-auto">
          <button
            onClick={() => {
              onSelectSlide(null);
              onClose();
            }}
            className="w-full px-4 py-3 text-left text-[#DFE4EA] hover:bg-[rgba(208,226,246,0.2)] transition-colors border-b border-[rgba(223,228,234,0.1)]"
          >
            Never
          </button>
          {Array.from({ length: totalSlides - currentSlideIndex - 2 }, (_, i) => {
            const slideIndex = currentSlideIndex + i + 2;
            const relativePosition = slideIndex - currentSlideIndex;
            const displayText = relativePosition === 2
              ? 'Next Slide'
              : `${relativePosition - 1} Slides`;

            return (
              <button
                key={slideIndex}
                onClick={() => {
                  onSelectSlide(slideIndex);
                  onClose();
                }}
                className="w-full px-4 py-3 text-left text-[#DFE4EA] hover:bg-[rgba(208,226,246,0.2)] transition-colors border-b border-[rgba(223,228,234,0.1)] last:border-b-0"
              >
                {displayText}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
